const yup = require("yup");

const paymentData = yup.object({
  programme: yup.string().required("Education subject is a required field"),
  rrr: yup.string().required("Remita rrr is a required field"),
  data: yup.object().required("Transaction data is a required field"),
});

module.exports = {
  paymentData,
};
